module.exports = __webpack_public_path__ + "media/toneA2.f7c1430a.mp3";